import React, { useState, useEffect, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './Gestion.css';

const Identidad = () => {
  const [flippedCards] = useState({});
  const haloRef = useRef(null);



  useEffect(() => {
    // Efecto halo que sigue al mouse
    const handleMouseMove = (e) => {
      if (haloRef.current) {
        haloRef.current.style.left = `${e.clientX}px`;
        haloRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const valuesData = [
    {
      id: 'Planificación',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF4799"
    viewBox="0 0 52 52"
  >
    <path d="m48.34 10-6.27-2v29.12L49.88 13a2.41 2.41 0 0 0-1.53-3zM20.52 5.59 16.81 6.8 3.66 11.08a2.42 2.42 0 0 0-1.55 3l10.18 31.35a2.41 2.41 0 0 0 3 1.57l14-4.56 2.85-.94a2.39 2.39 0 0 0 1.56-3L23.59 7.14a2.4 2.4 0 0 0-3-1.57zM37.34 34.06V7.3a2.41 2.41 0 0 0-2.41-2.41H27.8a6.07 6.07 0 0 1 .32.8l9.05 27.75a5.24 5.24 0 0 1 .17.62z" />
  </svg>
      ),
      title: 'Planificación',
    },
    {
      id: 'Ejecución',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF4799"
    stroke="#F8CF4799"
    strokeWidth={0.576}
    viewBox="0 0 48 48"
  >
    <title>{"assignment-priority-solid"}</title>
    <g data-name="Layer 2">
      <g fill="none" data-name="invisible box">
        <path d="M0 0h48v48H0z" />
        <path d="M0 0h48v48H0z" />
      </g>
      <path
        d="M40 6h-4V4a2 2 0 0 0-2-2H14a2 2 0 0 0-2 2v2H8a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2ZM24 38a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm2-10a2 2 0 0 1-4 0V16a2 2 0 0 1 4 0Z"
        data-name="icons Q2"
      />
    </g>
  </svg>
      ),
      title: 'Ejecución',
    },
    {
      id: 'Monitoreo y Control ',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF4799"
    stroke="#F8CF4799"
    baseProfile="full"
    viewBox="0 0 76 76"
  >
    <path
      strokeLinejoin="round"
      strokeWidth={0.2}
      d="M20 23h36a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2H41v4h4a2 2 0 0 1 2 2v2H29v-2a2 2 0 0 1 2-2h4v-4H20a2 2 0 0 1-2-2V25a2 2 0 0 1 2-2Zm1 3v20h34V26H21Zm2 2h4v4h-4v-4Zm6 0h24v4H29v-4Zm-6 6h4v4h-4v-4Zm6 0h24v4H29v-4Zm-6 6h4v4h-4v-4Zm6 0h24v4H29v-4Z"
    />
  </svg>
      ),
      title: 'Monitoreo y Control ',
    },
    {
      id: 'Cierre y Mejora Continua',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF4799"
    viewBox="0 0 47 47"
  >
    <path d="M9.702 33.114h-6.41c-1.18 0-2.136.956-2.136 2.136v9.614c0 1.18.957 2.136 2.136 2.136h6.409c1.18 0 2.137-.957 2.137-2.136V35.25c0-1.18-.957-2.136-2.136-2.136zM26.266 25.636h-6.409c-1.18 0-2.136.957-2.136 2.138v17.091c0 1.18.957 2.136 2.136 2.136h6.409c1.18 0 2.137-.957 2.137-2.136V27.773c0-1.18-.957-2.137-2.137-2.137zM42.833 17.091h-6.409c-1.18 0-2.137.957-2.137 2.136v25.637c0 1.18.957 2.136 2.137 2.136h6.409c1.18 0 2.137-.957 2.137-2.136V19.227a2.136 2.136 0 0 0-2.137-2.136z" />
    <circle cx={39.628} cy={1.521} r={1.521} />
    <path d="M45.671 1.028a.854.854 0 0 0-1.198-.172l-3.486 2.61h-.551a.837.837 0 0 0-.595.257l.399 2.928-.612.519-.612-.519.399-2.928a.834.834 0 0 0-.595-.257h-.55L34.785.856a.856.856 0 1 0-1.027 1.371l3.716 2.781a.848.848 0 0 0 .491.17v3.868l-1.582 5.536a.858.858 0 0 0 .824 1.093.857.857 0 0 0 .823-.622l1.598-5.594 1.598 5.594a.858.858 0 0 0 1.648-.471l-1.582-5.536V5.179a.848.848 0 0 0 .492-.17L45.5 2.227a.856.856 0 0 0 .171-1.199z" />
  </svg>
      ),
      title: 'Cierre y Mejora Continua',
    },
  ];

  const valuesData_2 = [
    {
      id: 'Inicio',
      icon: (

          <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF4729"
    stroke="#F8CF4729"
    viewBox="0 0 16 16"  >
    <g fill="#F8CF47">
      <path d="M4 0v6h1.7l.2.7.2.6h.1l1.2-.6 1.8 1.8-.6 1.2v.1l.6.2.7.2v.2L16 7 4 0zM4.5 10.5c-.2 0-.4.1-.5.2-.3.2-.5.5-.5.8s.2.7.5.8c.1.1.3.2.5.2.6 0 1-.4 1-1s-.4-1-1-1z" />
      <path d="M9 12v-1l-1.1-.4c-.1-.3-.2-.6-.4-.9l.5-1-.7-.7-1 .5c-.3-.2-.6-.3-.9-.4L5 7H4l-.4 1.1c-.3.1-.6.2-.9.4l-1-.5-.7.7.5 1.1c-.2.3-.3.6-.4.9L0 11v1l1.1.4c.1.3.2.6.4.9l-.5 1 .7.7 1.1-.5c.3.2.6.3.9.4L4 16h1l.4-1.1c.3-.1.6-.2.9-.4l1 .5.7-.7-.5-1.1c.2-.3.3-.6.4-.9L9 12zm-4.5 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </g>
  </svg>

      ),
      title: 'Inicio',
      subtitle: 'alineación del alcance',
    },
    {
      id: 'Planeación',
      icon: (
          <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 60 60"  >
    <path d="M22 22v2h12c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1H7c-3.9 0-7 3.1-7 7v14h2V24c0-2.8 2.2-5 5-5h1.3l2.8 7.4c.1.3.5.6.9.6s.8-.3 1.1-.6l2.8-7.4H33v3H22zm-9.9 1.2L10.5 19h3.2l-1.6 4.2z" />
    <path d="M17 58h-4V39h-2v19H7V25H5v34c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V25h-2v33z" />
    <path d="M11 29h2v2h-2zM11 33h2v2h-2zM11 16h2c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5h-2C8.2 3 6 5.2 6 8v3c0 2.8 2.2 5 5 5zM8 8c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3v3c0 1.7-1.3 3-3 3h-2c-1.7 0-3-1.3-3-3V8zM30 14h22c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1H30c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1zm1-12h20v10H31V2zM38 37H24c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h6v3h-6c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-6v-3h6c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1zm-1 21H25v-6h12v6zm0-13H25v-6h12v6zM59 47c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1H45c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h6v3h-6c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-6v-3h6zm-1 11H46v-6h12v6zM46 39h12v6H46v-6zM53 35v-3c0-.6-.4-1-1-1H42V16h-2v15h-9c-.6 0-1 .4-1 1v3h2v-2h19v2h2z" />
    <path d="M33 4h12v2H33zM33 8h16v2H33zM28 41h2v2h-2zM32 41h2v2h-2zM28 54h2v2h-2zM32 54h2v2h-2zM49 54h2v2h-2zM53 54h2v2h-2zM49 41h2v2h-2zM53 41h2v2h-2z" />
  </svg>

      ),
      title: 'Planeación',
      subtitle: 'WBS - Cronograma - Costo',
    },
    {
      id: 'Ejecución',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 52 52"
  >
    <path d="M20 37.5c0-.8-.7-1.5-1.5-1.5h-15c-.8 0-1.5.7-1.5 1.5v11c0 .8.7 1.5 1.5 1.5h15c.8 0 1.5-.7 1.5-1.5v-11zM8.1 22H3.2c-1 0-1.5.9-.9 1.4l8 8.3c.4.3 1 .3 1.4 0l8-8.3c.6-.6.1-1.4-.9-1.4h-4.7c0-5 4.9-10 9.9-10V6C15 6 8.1 13 8.1 22zM41.8 20.3c-.4-.3-1-.3-1.4 0l-8 8.3c-.6.6-.1 1.4.9 1.4h4.8c0 6-4.1 10-10.1 10v6c9 0 16.1-7 16.1-16H49c1 0 1.5-.9.9-1.4l-8.1-8.3zM50 3.5c0-.8-.7-1.5-1.5-1.5h-15c-.8 0-1.5.7-1.5 1.5v11c0 .8.7 1.5 1.5 1.5h15c.8 0 1.5-.7 1.5-1.5v-11z" />
  </svg>
      ),
      title: 'Ejecución',
      subtitle: 'recursos - frentes - QA/QC',
    },
    {
      id: 'Control',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 1920 1920"  >
    <path
      fillRule="evenodd"
      d="M1600 1066.667c117.653 0 213.333 95.68 213.333 213.333v106.667H1920V1760c0 88.213-71.787 160-160 160h-320c-88.213 0-160-71.787-160-160v-373.333h106.667V1280c0-117.653 95.68-213.333 213.333-213.333ZM800 0c90.667 0 179.2 25.6 254.933 73.6 29.867 18.133 58.667 40.533 84.267 66.133 49.067 49.067 84.8 106.88 108.053 169.814 11.307 30.4 20.8 61.44 25.814 94.08l2.24 14.613 3.626 20.16-.533.32v.213l-52.693 32.427c-44.694 28.907-95.467 61.547-193.067 61.867-.427 0-.747.106-1.173.106-24.534 0-46.08-2.133-65.28-5.653-.64-.107-1.067-.32-1.707-.427-56.32-10.773-93.013-34.24-126.293-55.68-9.6-6.293-18.774-12.16-28.16-17.6-27.947-16-57.92-27.306-108.16-27.306h-.32c-57.814.106-88.747 15.893-121.387 36.266-4.48 2.88-8.853 5.44-13.44 8.427-3.093 2.027-6.72 4.16-9.92 6.187-6.293 4.053-12.693 8.106-19.627 12.16-4.48 2.666-9.493 5.013-14.293 7.573-6.933 3.627-13.973 7.147-21.76 10.453-6.613 2.987-13.76 5.547-21.12 8.107-6.933 2.347-14.507 4.267-22.187 6.293-8.96 2.347-17.813 4.587-27.84 6.187-1.173.213-2.133.533-3.306.747v57.6c0 17.066 1.066 34.133 4.266 50.133C454.4 819.2 611.2 960 800 960c195.2 0 356.267-151.467 371.2-342.4 48-14.933 82.133-37.333 108.8-54.4v23.467c0 165.546-84.373 311.786-212.373 398.08h4.906a1641.19 1641.19 0 0 1 294.08 77.76C1313.28 1119.68 1280 1195.733 1280 1280h-106.667v480c0 1.387.427 2.667.427 4.16-142.933 37.547-272.427 49.173-373.76 49.173-345.493 0-612.053-120.32-774.827-221.333L0 1576.32v-196.373c0-140.054 85.867-263.04 218.667-313.28 100.373-38.08 204.586-64.96 310.186-82.347h4.8C419.52 907.413 339.2 783.787 323.2 640c-2.133-17.067-3.2-35.2-3.2-53.333V480c0-56.533 9.6-109.867 27.733-160C413.867 133.333 592 0 800 0Zm800 1173.333c-58.773 0-106.667 47.894-106.667 106.667v106.667h213.334V1280c0-58.773-47.894-106.667-106.667-106.667Z"
    />
  </svg>
      ),
      title: 'Control',
      subtitle: 'ravance - riesgos - cambios',

    },
    {
      id: 'Cierre',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 512 512"  >
    <path
      d="M26.7 330.048v156.091h156.224M26.7 486.139l195.443-195.347M486.25 182.962V26.814H330.025M486.25 26.814 290.807 222.162"
      style={{
        fill: "none",
        stroke: "#f8cf47",
        strokeWidth: 38.912,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 2.6131,
      }}
    />
  </svg>
      ),
      title: 'Cierre',
      subtitle: 'entregables - lecciones',

    },
  ];

  const mainImages = [
    { src: '/images/fotos/windalco1/Windalco1_1.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/windalco2/windalco2_2.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/windalco1/Windalco1_4.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/images/fotos/jamalcoPiping/jamalcoPiping_5.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/jamalcoPiping/jamalcoPiping_6.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/jamalcoLinner/jamalcoLinner_5.jpg', alt: 'Rever_foto' },
    { src: '/images/fotos/estructura/estructura_1.jpeg', alt: 'Rever_foto' },

  ];

  const carouselOptions = {
    type: 'loop',
    perPage: 1,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    resetProgress: false,
    height: '500px',
    speed: 1200,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
  };

  return (
    <div className="identidad-container">
      <div className="halo" ref={haloRef}></div>
      
      {/* Hero Section */}
<section className="hero-carousel-section">
  <div className="hero-carousel-text">
    <h1 className="hero-title">
      ¿Cómo gestiona <span className="highlight">Rêver</span> sus proyectos?
    </h1>
    <div className="animated-underline"></div>
    <p className="hero-subtitle">
      Project Management con enfoque PMI y Lean System
    </p>
    <p className="hero-subtitle">
      En Rêver gestionamos cada proyecto con un enfoque estructurado,
      colaborativo y orientado a resultados. Aplicamos estándares y mejores
      prácticas del PMI para planificar, ejecutar, monitorear y cerrar
      nuestros proyectos, integrando además principios de Lean System para
      maximizar valor, reducir retrabajos y fortalecer el desempeño en campo.
    </p>
  </div>

  <div className="hero-carousel-media">
    <Splide options={carouselOptions} className="main-carousel">
      {mainImages.map((image, index) => (
        <SplideSlide key={index}>
          <div className="carousel-slide">
            <img src={image.src} alt={image.alt} className="carousel-image" />
          </div>
        </SplideSlide>
      ))}
    </Splide>
  </div>
</section>

      <div className="section-divider"></div>


      {/* Values Section */}
      <section className="values-section">
        <div className="container">

          <div className="values-grid">
            {valuesData.map((value) => (
              <div 
                key={value.id} 
                className={`flip-card ${flippedCards[value.id] ? 'flipped' : ''}`}
              >
                <div className="flip-card-inner">
                  {/* Front Side */}
                  <div className="flip-card-front">
                    <button 
                      className="flip-button"
                      aria-label="Voltear tarjeta"
                      title="Rever Gestiones"
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
                      </svg>
                    </button>
                    
                    <div className="card-icon">
                      {value.icon}
                    </div>
                    <h3 className="card-title">{value.title}</h3>
                    
                    
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="container">
          <div className="mission-vision-grid">


            <div className="mission-vision-card">
              <div className="mission-vision-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 491.52 491.52"  >
    <path d="m260.735 263.056-31.073 31.072a22.898 22.898 0 0 1-16.29 6.75c-6.15 0-11.94-2.4-16.29-6.75-8.985-8.985-8.985-23.594 0-32.579l30.754-30.754a49.664 49.664 0 0 0-14.464-2.156c-27.473 0-49.822 22.35-49.822 49.83 0 27.472 22.349 49.822 49.822 49.822 27.48 0 49.83-22.35 49.83-49.822a49.62 49.62 0 0 0-2.467-15.413z" />
    <path d="m297.492 226.299-24.958 24.958c3.831 8.294 6.029 17.491 6.029 27.212 0 35.94-29.243 65.182-65.19 65.182-35.94 0-65.182-29.242-65.182-65.182 0-35.948 29.242-65.19 65.182-65.19 9.385 0 18.291 2.033 26.361 5.619l25.025-25.025c-15.008-9.151-32.561-14.524-51.387-14.524-54.652 0-99.112 44.468-99.112 99.12s44.46 99.112 99.112 99.112c54.652 0 99.119-44.46 99.119-99.112 0-19.154-5.552-36.995-14.999-52.17z" />
    <path d="m332.908 190.883-24.252 24.252c12.105 18.153 19.195 39.925 19.195 63.335 0 63.119-51.352 114.472-114.479 114.472-63.12 0-114.472-51.353-114.472-114.472 0-63.127 51.352-114.48 114.472-114.48 23.082 0 44.552 6.922 62.551 18.718l24.314-24.314c-24.453-17.741-54.412-28.334-86.865-28.334-81.832 0-148.402 66.577-148.402 148.409S131.54 426.87 213.372 426.87c81.831 0 148.409-66.569 148.409-148.402 0-32.775-10.81-63.002-28.873-87.585z" />
    <path d="m392.818 163.839-29.125-3.742-19.83 19.83c20.787 27.457 33.277 61.529 33.277 98.542 0 90.299-73.47 163.761-163.769 163.761-90.3 0-163.762-73.462-163.762-163.761S123.072 114.7 213.371 114.7c36.691 0 70.487 12.278 97.821 32.738l19.92-19.921-3.711-28.884C294.404 77.634 255.3 65.409 213.372 65.409 95.892 65.409.313 160.988.313 278.468S95.892 491.52 213.372 491.52s213.051-95.572 213.051-213.052c.001-42.182-12.372-81.504-33.605-114.629z" />
    <path d="M490.796 66.797a7.684 7.684 0 0 0-6.292-5.138l-40.664-5.218c.583-2.498.035-5.209-1.914-7.157-1.948-1.948-4.659-2.496-7.157-1.914l-5.218-40.664a7.684 7.684 0 0 0-5.137-6.292 7.662 7.662 0 0 0-7.913 1.838L342.964 75.79a7.692 7.692 0 0 0-2.19 6.404l6.533 50.85-139.365 139.364c-3 3-3 7.86 0 10.86a7.656 7.656 0 0 0 5.431 2.249 7.66 7.66 0 0 0 5.43-2.249l139.364-139.364 50.85 6.533a7.687 7.687 0 0 0 6.406-2.19L488.96 74.71a7.688 7.688 0 0 0 1.836-7.913z" />
  </svg>
              </div>
              <h3>Base PMI </h3>
              <p>
                Gestión del alcance,
EDT/WBS, cronograma,
costos, riesgos, calidad y
comunicaciones.
              </p>
            </div>

            <div className="mission-vision-card">
              <div className="mission-vision-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF47"
    className="cf-icon-svg cf-icon-svg__updating"
    viewBox="-1.7 0 20.4 20.4"
  >
    <path d="M16.416 10.283A7.917 7.917 0 1 1 8.5 2.366a7.916 7.916 0 0 1 7.916 7.917zM4.546 7.329a5.084 5.084 0 0 0-.908 2.139.792.792 0 0 0 .646.915.813.813 0 0 0 .135.011.792.792 0 0 0 .78-.657 3.506 3.506 0 0 1 .498-1.29v.324a.792.792 0 0 0 1.584 0V6.537a.792.792 0 0 0-.792-.792H4.255a.792.792 0 0 0 0 1.584zm1.117 4.865a3.548 3.548 0 0 1-.285-.58.792.792 0 1 0-1.479.566 5.097 5.097 0 0 0 .412.839.792.792 0 1 0 1.352-.825zm1.941 1.518a3.54 3.54 0 0 1-.596-.249.792.792 0 0 0-.742 1.399 5.163 5.163 0 0 0 .862.36.792.792 0 1 0 .476-1.51zM8.74 6.825a.792.792 0 0 0 .014-1.583h-.008a.792.792 0 1 0-.028 1.583h.007zm1.601 8.33a.792.792 0 1 0-.523-1.495 3.381 3.381 0 0 1-.309.092.792.792 0 0 0 .19 1.56.806.806 0 0 0 .193-.023c.151-.038.302-.083.45-.134zm.581-7.688A.792.792 0 0 0 11.336 6l-.003-.002a.792.792 0 0 0-.835 1.346l.013.007a.787.787 0 0 0 .411.116zm1.722 4.692a.792.792 0 0 0-1.103.195 3.574 3.574 0 0 1-.196.256.792.792 0 0 0 1.208 1.023c.1-.12.197-.244.286-.371a.792.792 0 0 0-.195-1.103zm-.876-3.458.007.013a.792.792 0 0 0 1.398-.744l-.002-.002a.792.792 0 1 0-1.403.733zm1.233 1.066a.792.792 0 0 0-.83.75 3.623 3.623 0 0 1-.01.13.791.791 0 0 0 .72.857.767.767 0 0 0 .07.004.792.792 0 0 0 .787-.723c.006-.062.01-.124.013-.187a.791.791 0 0 0-.75-.83z" />
  </svg>
              </div>
              <h3>Lean System</h3>
              <p>
                Planificación colaborativa,
lookahead planning,
gestión de restricciones y
mejora continua.
              </p>
            </div>

                        <div className="mission-vision-card">
              <div className="mission-vision-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF47"
    viewBox="0 0 48 48"
  >
    <title>{"computer-setting"}</title>
    <g data-name="Layer 2">
      <path fill="none" d="M0 0h48v48H0z" data-name="invisible box" />
      <g data-name="icons Q2">
        <path d="M7 34h12a2 2 0 0 0 0-4H9V10h30v20H29a2 2 0 0 0 0 4h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2ZM44 38H4a2 2 0 0 0 0 4h40a2 2 0 0 0 0-4Z" />
        <path d="M31.9 21.3A5.7 5.7 0 0 0 32 20a5.7 5.7 0 0 0-.1-1.3l-2.2-.5a4.2 4.2 0 0 0-.4-1l1.2-1.9a7.7 7.7 0 0 0-1.8-1.8l-1.9 1.2-1-.4-.5-2.2h-2.6l-.5 2.2-1 .4-1.9-1.2a7.7 7.7 0 0 0-1.8 1.8l1.2 1.9a4.2 4.2 0 0 0-.4 1l-2.2.5A5.7 5.7 0 0 0 16 20a5.7 5.7 0 0 0 .1 1.3l2.2.5a4.2 4.2 0 0 0 .4 1l-1.2 1.9a7.7 7.7 0 0 0 1.8 1.8l1.9-1.2 1 .4.5 2.2h2.6l.5-2.2 1-.4 1.9 1.2a7.7 7.7 0 0 0 1.8-1.8l-1.2-1.9a4.2 4.2 0 0 0 .4-1ZM24 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z" />
      </g>
    </g>
  </svg>
              </div>
              <h3>Control del Proyecto</h3>
              <p>
                Seguimiento de KPIs,
avance físico,
productividad, costos
y gestión de cambios.
              </p>
            </div>


                        <div className="mission-vision-card">
              <div className="mission-vision-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 458.123 458.123"
  >
    <path d="M201.777 401.234c-6.124-4.595-12.371-10.064-18.551-16.245-.471-.473-61.162-61.307-93.851-94.034a12.498 12.498 0 0 0-19.723 2.677c-3.799 6.715-5.324 12.845-4.532 18.218 1.358 9.223 9.004 18.481 20.035 29.511l65.832 66.311c11.021 11.021 20.251 18.64 29.478 20a19.71 19.71 0 0 0 2.866.206c5.283 0 11.204-2.04 17.6-6.063a12.497 12.497 0 0 0 5.833-10.067 12.499 12.499 0 0 0-4.987-10.514zM356.229 246.735l-3.666-4.333a204.306 204.306 0 0 0-2.955-3.458l-.119-.133a262.069 262.069 0 0 0-9.506-9.983l-1.201-1.202a9.49 9.49 0 0 0-.27-.26c-29.479-27.77-55.748-28.096-83.566-28.44-17.805-.22-34.624-.428-52.621-7.072-17.623-6.506-33.936-20.103-44.756-37.304-10.137-16.115-13.78-33.249-9.747-45.828.144-.45.323-.949.532-1.488l17.321-17.319c9.779-9.78 9.779-25.693-.001-35.475l-19.146-19.146a12.5 12.5 0 0 0-17.678 0L3.661 160.483a12.505 12.505 0 0 0 0 17.679l19.146 19.145c4.738 4.738 11.038 7.348 17.737 7.348 6.699 0 12.999-2.608 17.737-7.347l15.548-15.548c8.873 16.078 10.264 31.474 11.499 45.147 1.27 14.042 2.187 24.188 10.401 32.401 26.045 26.046 105.997 106.187 106.503 106.695 18.564 18.562 34.997 27.587 50.233 27.587a37.5 37.5 0 0 0 4.42-.26c13.299-1.567 26.965-10.003 44.312-27.352l39.107-39.107c21.307-21.308 30.252-34.844 30.873-46.723.48-9.198-4.326-20.028-14.697-33.107a14.553 14.553 0 0 0-.251-.306z" />
    <path d="M454.461 159.098 329.271 33.906c-4.883-4.882-12.797-4.882-17.678 0l-19.145 19.146c-9.781 9.781-9.781 25.695 0 35.476l5.707 5.708c-19.286 12.094-48.024 25.681-79.774 25.683-9.262 0-18.341-1.195-27.029-3.564a12.498 12.498 0 0 0-14.7 17.311c5.202 11.181 17.484 26.527 34.978 32.986 13.652 5.041 28.898 5.23 43.643 5.413 30.422.376 68.283.846 108.289 42.371a12.495 12.495 0 0 0 13.033 3.16 12.5 12.5 0 0 0 8.393-10.46c.908-8.217 2.338-15.192 4.449-21.619l10.406 10.404c4.736 4.738 11.037 7.347 17.738 7.347 6.699 0 12.998-2.608 17.736-7.348l19.145-19.146c4.882-4.88 4.882-12.795-.001-17.676z" />
  </svg>
              </div>
              <h3>Confianza para el Cliente</h3>
              <p>
                Descisiones oportunas,
trazabilidad y enfoque
en seguridad, plazo,
calidad y presupuesto
              </p>
            </div>

          </div>
        </div>
      </section>

            <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Gestión de Proyectos
basada en estándares <span className="highlight">PMI</span>
            </h2>
            <div className="animated-underline"></div>
            <p className="section-subtitle">
              Rêver estructura cada proyecto con gobernanza, planeación
integrada y control continuo de alcance, cronograma, costos,
riesgos, calidad y cierre documentado.
            </p>
          </div>

          <div className="values-grid">
            {valuesData_2.map((value) => (
              <div 
                key={value.id} 
                className={`flip-card ${flippedCards[value.id] ? 'flipped' : ''}`}
              >
                <div className="flip-card-inner">
                  {/* Front Side */}
                  <div className="flip-card-front">
                    <button 
                      className="flip-button"
                      aria-label="Gestión de Proyectos"
                      title="Gestión de Proyectos"
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
                      </svg>
                    </button>
                    
                    <div className="card-icon">
                      {value.icon}
                    </div>
                    <h3 className="card-title">{value.title}</h3>
                    <p className="card-subtitle">{value.subtitle}</p>                    
                    
                  </div>
                </div>


        </div>

        

            ))}
          </div>
                                    <div className="animated-underline"></div>

                                          <section className="identidad-hero">
        <div className="container">
          <h1 className="hero-title">
            <span className="highlight">Confianza para el cliente</span>
          </h1>
          <div className="animated-underline"></div>
          <p className="hero-subtitle">
            Trazabilidad de decisiones - visibilidad de restricciones -
control de desvios - entrega predecible
          </p>
        </div>
      </section>

        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>
    </div>
  );
};

export default Identidad;